import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { ContactSupportBase } from 'components/ContactSupport';
import DentistNavbar from 'components/DentistNavbar/DentistNavbar';
import { usePersistedApi } from 'hooks';
import Api from 'api';
import entities from 'reduxStore/entityKeys';
import { UserAccountProps } from 'utils/types';
import { nativePageShell, nativePageScrollRegion } from 'styles/nativePageLayout';

const PageShell = styled.div`
  ${nativePageShell}
`;

const PageScroll = styled.div`
  ${nativePageScrollRegion}
`;

const ContactSupport: React.FC = () => {
    const history = useHistory();

    const [user] = usePersistedApi({
        apiMethod: Api.getUser,
        entityName: entities.user,
        initialValue: {} as UserAccountProps,
    });

    const dentist = (user as any)?.dentist;
    const firstName = (user as any)?.firstName || dentist?.firstName || '';
    const lastName = (user as any)?.lastName || dentist?.lastName || '';
    const photoUrl = (user as any)?.photoUrl || dentist?.photoUrl || undefined;

    // Ensure back returns to React DentistHome instead of legacy home.html
    const handleBack = () => history.push('dentistHome');

    const handleGetTemp = () => history.push('dentistHome');

    return (
        <PageShell>
            <DentistNavbar
                firstName={firstName}
                lastName={lastName}
                photoUrl={photoUrl}
                onGetTempClick={handleGetTemp}
                showGetTempButton={false}
            />
            <PageScroll>
                <ContactSupportBase onBack={handleBack} hideNotificationBell hideTopBar />
            </PageScroll>
        </PageShell>
    );
};

export default ContactSupport; 
